import React from "react";
import ProjectFeatureMapPageV2 from "./ProjectFeatureMapPageV2";

const ProjectFeatureMapContainer = () => {
  return <ProjectFeatureMapPageV2 />;
};

export default ProjectFeatureMapContainer;
